import {
  Button,
  EHeadingStyleVariant,
  ETextStyleVariant,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import mediaUrl from '@/assets/referral/refer-an-owner.jpg';
import MaxWidth from '@/components/common/layout/MaxWidth';
import { useRouter } from '@/hooks/useRouter';
import { selectAuthenticated } from '@/redux/modules/auth/selectors';
import { triggerLoginModal } from '@/utility/triggerLoginModal';

export const ReferHosts = () => {
  const intl = useIntl();
  const router = useRouter();

  const isAuthenticated = useSelector(selectAuthenticated);

  return (
    <MaxWidth className="py-10 m-auto text-center grid md:grid-cols-2 gap-6 md:gap-10 md:text-left">
      <div className="flex flex-col gap-6">
        <div className="relative h-[220px] md:h-[350px] rounded-2xl overflow-clip">
          <Image
            alt=""
            src={mediaUrl}
            role="presentation"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            loading="lazy"
          />
        </div>
      </div>

      <div className="flex flex-col justify-center gap-4">
        <Heading variant={EHeadingStyleVariant.H4}>
          <FormattedMessage
            defaultMessage="Refer your RV friends to become a host and earn together."
            id="1J3AlG"
          />
        </Heading>

        <Text variant={ETextStyleVariant.MediumRegular} className="text-gray-700">
          <FormattedMessage
            defaultMessage="They'll get $50 off their hosting fees just for signing up on Outdoorsy, and you’ll get $100 once they host their first guest."
            id="6DoYN0"
          />
        </Text>

        <div>
          <Button
            label={intl.formatMessage({ defaultMessage: 'Refer a host', id: 'ceae+7' })}
            onClick={() => {
              if (!isAuthenticated) {
                triggerLoginModal(0);
                return;
              }

              router.push('/referral/owner', undefined, {
                shallow: true,
              });
            }}
            className="w-full md:w-auto"
          />
        </div>
      </div>
    </MaxWidth>
  );
};
